import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const headTable = () => {
  return [
    {
      no: "No.",
      name: "Nama",
      total_tagihan: "Total Tagihan",
      total_pembayaran: "Total Pembayaran",
      kekurangan: "Kekurangan Pembayaran",
    },
  ];
};

const getBillAmount = (x) => {
  if (x.status === "WAITING INPUT BILL") {
    return x.total_sales ?? x.grand_total ?? 0;
  }
  return x.grand_total ?? 0;
};

const drawStatusTables = (doc, data) => {
  const statusOrder = [
    "WAITING PAYMENT",
    "PENDING PAYMENT",
    "WAITING INPUT BILL",
  ];

  statusOrder.forEach((status) => {
    const statusItems = data?.data?.filter((x) => x.status === status) || [];
    if (!statusItems.length) return;

    const schoolGroups = {};
    statusItems.forEach((x) => {
      const name = x.client?.name || "";
      if (!schoolGroups[name]) {
        schoolGroups[name] = {
          name,
          total_tagihan: 0,
          total_pembayaran: 0,
          kekurangan: 0,
        };
      }
      schoolGroups[name].total_tagihan += Number(getBillAmount(x));
      schoolGroups[name].total_pembayaran += Number(x.total_payment ?? 0);
      schoolGroups[name].kekurangan += Number(x.outstanding_payment ?? 0);
    });

    const sortedSchools = Object.values(schoolGroups).sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    const body = sortedSchools.map((x, i) => [
      { content: `${i + 1}.` },
      { content: x.name },
      { content: `Rp. ${x.total_tagihan.toLocaleString("id-ID")}` },
      { content: `Rp. ${x.total_pembayaran.toLocaleString("id-ID")}` },
      { content: `Rp. ${x.kekurangan.toLocaleString("id-ID")}` },
    ]);

    const total_tagihan = sortedSchools.reduce(
      (sum, x) => sum + x.total_tagihan,
      0
    );
    const total_pembayaran = sortedSchools.reduce(
      (sum, x) => sum + x.total_pembayaran,
      0
    );
    const kekurangan = sortedSchools.reduce((sum, x) => sum + x.kekurangan, 0);

    body.push([
      {
        content: "Total",
        colSpan: 2,
        styles: { halign: "center", valign: "middle", fontStyle: "bold" },
      },
      {
        content: `Rp. ${total_tagihan.toLocaleString("id-ID")}`,
        styles: { fontStyle: "bold" },
      },
      {
        content: `Rp. ${total_pembayaran.toLocaleString("id-ID")}`,
        styles: { fontStyle: "bold" },
      },
      {
        content: `Rp. ${kekurangan.toLocaleString("id-ID")}`,
        styles: { fontStyle: "bold" },
      },
    ]);

    doc.text(status, 14, doc.lastAutoTable.finalY + 10);

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 14,
      theme: "grid",
      headStyles: { fillColor: [47, 84, 150], textColor: "white" },
      head: headTable(),
      body,
      columnWidth: "wrap",
      tableWidth: "auto",
      styles: {
        overflow: "linebreak",
        overflowColumns: "linebreak",
        textColor: "black",
      },
    });
  });
};

const SchoolDebtReportPDF = (data, year, employeeName) => {
  let doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "portrait",
    format: [210, 330],
  });

  let result =
    data?.data?.map((x, i) => ({
      no: `${i + 1}.`,
      name: x.client?.name || "",
      total_tagihan: `Rp. ${getBillAmount(x).toLocaleString("id-ID")}`,
      total_pembayaran: `Rp. ${x.total_payment?.toLocaleString("id-ID")}`,
      kekurangan: `Rp. ${x.outstanding_payment?.toLocaleString("id-ID")}`,
    })) || [];

  const grand_total = Number(data?.total ?? 0);

  if (!result.length) {
    result = [
      [
        {
          content: "Tidak ada data",
          colSpan: 5,
          styles: { halign: "center", valign: "middle", fontStyle: "bold" },
        },
      ],
    ];
  }

  const gt = [
    [
      {
        content: "Total",
        colSpan: 4,
        styles: { halign: "center", valign: "middle", fontStyle: "bold" },
      },
      {
        content: `Rp. ${grand_total.toLocaleString("id-ID")}`,
        styles: { fontStyle: "bold" },
      },
    ],
  ];

  doc.setFontSize(10);
  doc.setFont("times", "bold");
  doc.text("Laporan Total Piutang Sekolah", 14, 10);
  doc.text(`Tahun ${year}`, 14, 15);
  doc.text(`Nama Marketing: ${employeeName}`, 14, 20);

  autoTable(doc, {
    startY: 23,
    theme: "grid",
    headStyles: { fillColor: [47, 84, 150], textColor: "white" },
    head: headTable(),
    body: [...result, ...gt],
    columnWidth: "wrap",
    tableWidth: "auto",
    styles: {
      overflow: "linebreak",
      overflowColumns: "linebreak",
      textColor: "black",
    },
  });

  drawStatusTables(doc, data);

  doc.setProperties({
    title: "Laporan Piutang Sekolah",
  });

  window.open(
    doc.output("bloburl", {
      filename: "Laporan Piutang Sekolah.pdf",
    })
  );
};

export default SchoolDebtReportPDF;
